export default (props, vars) => props?.['name'] === 'rule-red';
